import React from "react";

export default class Share extends React.Component {
  state = {};

  componentDidMount() {
    const arr = window.location.href.split("#");
    if (arr.length > 1) {
      const uid = arr[1];
      this.redirect(uid);
    }
  }

  redirect(uid) {
    var now = new Date().valueOf();
    setTimeout(function() {
      if (new Date().valueOf() - now > 100) return;
      window.location = "https://itunes.apple.com/";
    }, 5);
    const appURL = "Trim-Direct://" + uid;

    window.location.href = appURL;
  }

  render() {
    return <div style={{ margin: 16 }} />;
  }
}
